import { useCallback } from 'react';

/**
 * This hook returns URLSearchParams with casinoname, site and t parameters.
 * Needed for hub2shared.
 */
export const useGetCMSResourceURL = () => {
    return useCallback((url, originalParams) => {
        const search = new URLSearchParams(window.location.search);
        const casinoname = search.get('casinoname');
        const site = search.get('site');
        const params = { ...originalParams };

        if (casinoname) {
            params.casinoname = casinoname;
        }

        if (site) {
            params.site = site;
        }

        return `${url}?${new URLSearchParams(params)}`;
    }, []);

};
